/*
 * @Descripttion:
 * @version:
 * @Author: guoye
 * @Date: 2025-07-06 14:54:07
 * @LastEditors: guoye
 * @LastEditTime: 2025-07-15 15:51:49
 */
import { model, registerModel, uniStorage } from '@sdk-common/pinia'

// 访问一下 model 的属性，触发注册
console.log('可用的 store:', Object.keys(model))

export { model, registerModel, uniStorage }
